interface BchLogoProps {
  className?: string;
  /**
   * When true (default) renders the branded coin image. Set false for a
   * lightweight CSS-only glyph fallback (e.g. tiny inline marks).
   */
  image?: boolean;
}

/** The Bitcoin Cash game coin mark. */
export function BchLogo({ className, image = true }: BchLogoProps) {
  if (image) {
    return (
      <img
        src="/logo.png"
        alt="Survive on BCH"
        className={`inline-block object-contain select-none ${className ?? ""}`}
        draggable={false}
      />
    );
  }

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground font-black ${className ?? ""}`}
      aria-label="Bitcoin Cash"
    >
      <span className="leading-none">₿</span>
    </div>
  );
}
